<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length"></div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <b-button v-b-modal.lpo-modal variant="primary"><i class="fa fa-plus"></i> New LPO
                  </b-button>
                  <!--GENERATING NEW LPO MODAL-->
                  <b-modal id="lpo-modal" hide-footer @hidden="resetData">
                    <template #modal-title> GENERATE NEW LPO</template>
                    <div class="form-group mb-3">
                      <label>Choose a Supplier</label>
                      <model-list-select
                          :list="Suppliers ? Suppliers : []"
                          v-model="data.supplier"
                          option-value="id"
                          option-text="name"
                          placeholder="Select Supplier"
                          @input="resetErrors()"
                      >
                      </model-list-select>
                    </div>
                    <div class="text-danger" v-if="supError">
                      <em>{{ supError }}</em>
                    </div>
                    <div class="modal-footer">
                      <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="closeMode('lpo-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button type="button" class="btn btn-primary" @click="generate('lpo-modal')">
                        <i class="fa fa-check"></i>
                        Generate
                        <b-spinner
                            v-if="GeneratingStatus"
                            variant="light"
                            small
                            label="Saving"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->

                  <!--DELETING SERVICE MODAL-->
                  <b-modal
                    id="delete-modal"
                    header-bg-variant="warning"
                    header-text-variant="light"
                    ref="modal"
                    size="sm"
                    centered
                    title="Confirmation Alert"
                    @hidden="resetData"
                    @ok="confirmDelete"
                  >
                    <div class="d-block text-center">
                      <h5>
                        Are you sure you want to delete local purchase order No.
                        <code>{{ deleteData.code }}</code
                        >? <br />
                        Click <code>OK</code> to continue
                      </h5>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="this.purchaseOrders"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(state)="data">
                  <span v-if="data.item.status == 1">Approved</span>
                  <span v-if="data.item.status == 0">Pending</span>
                </template>
                <template #cell(action)="data">
                  <router-link
                      v-if="user_permissions.view_lpo_details==1 && data.item.status==1 && data.item.received==0"
                      :to="{
                      name: 'LPOStocking',
                      params: {
                        id: data.item.id,
                      },
                    }">
                    <b-button size="sm" variant="secondary"
                    ><i class="fa fa-hand-holding-medical"></i> Receive Stock
                    </b-button>
                  </router-link>
                  <b-button size="sm" title="Receiving stock for this LPO is not available" variant="secondary" v-else
                  ><i class="fa fa-ban"></i> Receive Stock
                  </b-button>
                  |
                  <router-link
                    v-if="user_permissions.view_lpo_details==1"
                    :to="{
                      name: 'LPODetails',
                      params: {
                        id: data.item.id,
                      },
                    }">
                    <b-button size="sm" variant="primary"
                      ><i class="fa fa-eye"></i> Details
                    </b-button>
                  </router-link>
                  <b-button size="sm" variant="primary" disabled v-else
                    ><i class="fa fa-ban"></i> Details
                  </b-button>
                  |
                  <!-- Delete Modal -->
                  <b-button
                    v-if="user_permissions.delete_lpo==1 && data.item.received==0"
                    v-b-modal.delete-modal
                    size="sm"
                    variant="danger"
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete
                  </b-button>

                  <b-button
                    v-else
                    disabled
                    v-b-modal.delete-modal
                    size="sm"
                    variant="danger"
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete
                  </b-button>

                </template>
              </b-table>
              <h3 v-if="!this.purchaseOrders" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";

import { mapGetters, mapActions, mapState } from "vuex";

export default {
  page: {
    title: "Pharmacy Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    ModelListSelect
  },

  data() {
    return {
      title: "Local Purchase Orders",
      items: [
        {
          text: "Pharmacy Section",
          href: "#",
        },
        {
          text: "Facility LPOs",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "invoiceCode",
          sortable: true,
          label: "ORDER ID",
        },
        {
          key: "date",
          sortable: true,
          label: "TIME",
        },
        {
          key: "addedBy.name",
          sortable: true,
          label: "ADDED BY",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "state",
          sortable: true,
          label: "STATUS",
        },
        {
          key: "action",
          sortable: false,
          label: "ACTION",
        },
      ],
      data:{
        supplier: "",
      },
      deleteData: {
        id: "",
        code: "",
      },
      model_id: "",
      supError: "",
    };
  },

  computed: {
    ...mapGetters("purchaseOrder", ["purchaseOrders", "GeneratingStatus"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapGetters("pharmacy", ["Suppliers"]),
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),

    rows() {
      return this.purchaseOrders ? this.purchaseOrders.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.purchaseOrders ? this.purchaseOrders.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchPurchaseOrders: "purchaseOrder/fetchPurchaseOrders",
      SubmitRequest: "purchaseOrder/generateOrder",
      DeleteLPO: "purchaseOrder/deleteOrder",
      FetchSuppliers: "pharmacy/fetchSuppliers",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering Separator
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    generate(modelId) {
      this.model_id = modelId;
      if (this.data.supplier == "") {
        this.supError = "Please select a supplier";
        return;
      } else {
        this.supError = "";
      }
      this.SubmitRequest(this.data);
    },

    resetData(){
      this.data.supplier = "";
      this.deleteData.id = "";
      this.deleteData.code = "";
      this.resetErrors();
    },

    // CLOSE MODEL
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },

    resetErrors() {
      this.supError = "";
    },

    showDeleteModal(data) {
      this.deleteData.code = data.item.invoiceCode;
      this.deleteData.id = data.item.id;
    },

    confirmDelete() {
      // Push the data submitted to the endpoint
      this.DeleteLPO(this.deleteData);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("delete-modal");
      });
    },
  },

  created() {
    this.FetchPurchaseOrders();
    this.FetchSuppliers();
  },
};
</script>
<style lang="css" scoped></style>
